import _ from 'lodash';
import { connect } from 'react-redux';
import { get, update, add } from '../../modules/logistics/bulkCustomer';
import { showErrors } from '../../modules/general';
import { bindActionCreators } from 'redux';

const mapStateToProps = (state, ownProps) => {
	let bulkCustomer;
	let bulkCustomerId;

	if (ownProps.bulkCustomer) {
		bulkCustomer = ownProps.bulkCustomer;
	} else {
		bulkCustomerId = (ownProps.bulkCustomerId)
			? ownProps.bulkCustomerId
			: _.get(ownProps, ['match', 'params', 'bulkCustomerId']);
		bulkCustomer = _.get(state.maps, ['bulkCustomer', bulkCustomerId]);
	}

	return {
		bulkCustomer,
		stationMap : state.maps.station,
		userMap : state.maps.user,
		resourceMap : state.maps.resource,
		carrierMap : state.maps.carrier,
		terminalMap : state.maps.terminal,
		supplierMap : state.maps.supplier,
	};
};

const mapDispatchToProps = dispatch => bindActionCreators({
	getBulkCustomer : get,
	addBulkCustomer : add,
	updateBulkCustomer : update,
	showErrors,
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
);
